import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import {  getTournamentRegisterFormIsLoading } from '../../../../../../../store/selectors';
import { useTranslation } from 'react-i18next';

const TournamentRegisterResumeButton = ({ tournament, onResume, onRegister, onUnregister, short, buttonClassnames, onGameFromLobby, showLobbyFromGame, btnClassesNames, isLobby }) => {
  const { t } = useTranslation();
  const primaryClass = btnClassesNames && btnClassesNames.primary ? btnClassesNames.primary : '';
  const [started, finished, startsToday, startsIn, startsOn] = useMemo(() => {
    const now = moment();
    const startsAt = moment(tournament.startDate);
    const endsAt = moment(tournament.endDate);
    const d = moment.duration(startsAt.diff(now));
    return [
      (!!tournament.startDate && !now.isBefore(startsAt)) || (tournament.tournamentType === 'sitngo' && tournament.tournamentState === 'inProgress'),
      tournament.playerStatus === 'finished' ||
        tournament.tournamentState === 'refund' ||
        endsAt.isBefore(now),
      now.isSame(startsAt, 'date'),
      d.humanize(),
      short ? startsAt.format('MMM DD | HH:mm') : startsAt.format('MMM Do | HH:mm'),
    ];
  }, [short, tournament]);

  const [regStarted, regFinished, regStartsToday, regStartsIn, regStartsOn] = useMemo(() => {
    const now = moment();
    const startsAt = moment(tournament.registrationStartDate);
    const endsAt = moment(tournament.registrationEndDate);
    const d = moment.duration(startsAt.diff(now));
    return [ 
      (!!tournament.startDate && !now.isBefore(startsAt)) || (tournament.tournamentType === 'sitngo' && tournament.tournamentState === 'registration'),
      ['finished', 'refund', 'ready', 'inProgress'].includes(tournament.tournamentState) || endsAt.isBefore(now),
      now.isSame(startsAt, 'date'),
      d.humanize(),
      short ? startsAt.format('MMM DD | HH:mm') : startsAt.format('MMM Do | HH:mm'),
    ];
  }, [short, tournament]);

  const registerClassNames = buttonClassnames ? buttonClassnames.register : 'tournaments__buttons__register tournaments__buttons__button primary';
  const finishedClosedClassNames = buttonClassnames ? buttonClassnames.finish_lateReg_closed : 'tournaments__buttons__not-started tournaments__buttons__button primary';
  const resumeClassNames = buttonClassnames ? buttonClassnames.resume_rebuy : 'tournaments__buttons__resume tournaments__buttons__button primary';
  const tournamentRegisterFormIsLoading = useSelector(getTournamentRegisterFormIsLoading);
  const getClasses = concated => [concated, primaryClass].join(' ');
  return (
    <React.Fragment>
      {tournament.playerStatus === 'notRegistered' && regStarted  && !regFinished && (
        <button className={getClasses(registerClassNames)} onClick={() => onRegister(tournament)} disabled={tournamentRegisterFormIsLoading}>
          {tournament.tournamentState === 'lateRegistration' ? t('tournaments.lateRegistration') : `${t('register')}` }
        </button>
      )}
      {tournament.playerStatus === 'notRegistered' && (!regStarted || regFinished) &&(
        <button className={getClasses(finishedClosedClassNames)} disabled>
          {!regFinished && regStartsToday && (
            <span className="tournaments__buttons__starts-today">
              <span className="tournaments__buttons__starts-datetime">{t('tournaments.regOpenIn', {time: regStartsIn})}</span>
            </span>
          )}
          {!regFinished && !regStartsToday && (
            <span className="tournaments__buttons__starts-later">
              Reg. opens on
              <span className="tournaments__buttons__starts-datetime">{regStartsOn}</span>
            </span>
          )}
          {regFinished && tournament.tournamentState === 'finished' && (
            <span className="tournaments__buttons__finished">{t('tournaments.finished')}</span>
          )}
          {regFinished && tournament.tournamentState !== 'finished' && (
            <span className="tournaments__buttons__finished">{t('tournaments.registrationClosed')}</span>
          )}
        </button>
      )}
      {tournament.playerStatus !== 'notRegistered' && started && !finished && (
        <button className={getClasses(resumeClassNames)} onClick={() => showLobbyFromGame ? onGameFromLobby() : onResume(tournament)}>
          {isLobby ? t('tournaments.resumeToTournament') : t('tournaments.resume')}
        </button>
      )}
      {tournament.playerStatus !== 'notRegistered' && ((!started && startsToday) || finished) && (
        <button className={getClasses(finishedClosedClassNames)} disabled>
          {!finished && startsToday && (
            <span className="tournaments__buttons__starts-today">
              {short ? `${t('tournaments.startsIin', {time: startsIn})}` : `${t('tournaments.tournamentStartsIn')} ${startsIn}`}
            </span>
          )}
          {finished && (
            <span className='tournaments__buttons__finished'>{t('tournaments.outOfSpins')}</span>
          )}
        </button> 
      )}
      {!isLobby && tournament.playerStatus !== 'notRegistered' && !started && (!finished && !startsToday) &&
        <button className={getClasses(finishedClosedClassNames)} disabled>
          <span className="tournaments__buttons__starts-later">
              {short ? 'Starts on' : 'Tournament starts on'} 
              <span className="tournaments__buttons__starts-datetime">{startsOn}</span>
            </span>
        </button>
      }
      {isLobby && tournament.playerStatus === 'registered' && !started &&
        <button className="tournaments__buttons__unregister tournaments__lobby__header--mobile__button primary" onClick={() => onUnregister(tournament)}>
          {t('tournaments.unregister')}
        </button>
      }
    </React.Fragment>
  );
}

export default TournamentRegisterResumeButton;